module.exports = __webpack_public_path__ + "static/img/product.170c1b6b.jpg";